export default "__VITE_ASSET__bgZHzJ_W__"